// extracted by mini-css-extract-plugin
module.exports = {"conferences-previous":"conferences-previous_conferences-previous__14wNr","items":"conferences-previous_items__2WKVx","item":"conferences-previous_item__1MTel"};